export default __webpack_public_path__ + "static/media/16.3ae2b5d8.jpg";